module.exports = __webpack_public_path__ + "static/media/Icon-awesome-linkedin.35a730d3.svg";